var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPackage = function SvgPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "30px",
    viewBox: "19 76 32 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICN-package",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(20.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounds",
    fill: "#D0011B",
    opacity: 0,
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#EEC649",
    points: "14.9514 16.5821733 4.6551 22.0460511 4.6551 11.011804 14.9514 4.9337358 25.0893 11.011804 25.0893 22.0460511"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#07090B",
    opacity: 0.2,
    points: "14.9514 4.9337358 25.0893 11.011804 25.0893 22.0460511 14.9514 16.5821733"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#07090B",
    opacity: 0.15,
    points: "14.9514 4.9337358 4.6551 11.011804 4.6551 22.0460511 14.9514 16.5821733"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#BFBFBF",
    points: "14.9514 16.4732955 4.6551 11.0097159 4.6551 22.0436648 14.9514 28.1220312 25.0893 22.0436648 25.0893 11.0097159"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#F2F2F2",
    points: "-1.0658141e-15 13.6663352 4.6551 11.0097159 14.9514 16.4732955 10.0101 19.2802557"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#DEDEDE",
    points: "-1.0658141e-15 8.35548295 4.6551 11.011804 14.9604 4.93522727 10.0194 2.12796875"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#07090B",
    opacity: 0.05,
    points: "19.6065 20.9196875 25.0893 18.1166051 25.0893 11.011804 15.0324 16.429446 14.9514 16.4732955"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#F2F2F2",
    points: "14.9514 16.4732955 19.6065 19.1299148 30 13.8166761 25.0893 11.011804"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#DEDEDE",
    points: "14.9604 4.93522727 19.6155 2.27860795 30 8.20723011 25.0893 11.011804"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#1FAECE",
    points: "14.9514 2.94887784 4.6551 8.41036932 4.6551 11.0353693 14.9514 16.4732955 25.0893 11.011804 25.0893 8.38680398"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#07090B",
    opacity: 0.05,
    points: "14.9514 13.8482955 4.6551 8.41036932 4.6551 11.0353693 14.9514 16.4732955"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#07090B",
    opacity: 0.1,
    points: "14.9514 13.8482955 25.0893 8.38680398 25.0893 11.011804 14.9514 16.4732955"
  }))));
};
export default SvgPackage;